module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-16-8f1a0b26ab88c0df292e1cf12ed3b13e.png";